import MojitoServices from 'mojito/services';

import {GuidesContentGenerator} from './guides-content-generator.js';

const {AbstractQuickStartGuideService} = MojitoServices.QuickStartGuide;
const DELAY = 200;

/**
 * Class offering the possibility to interact with the mojito Quick start guide API.
 *
 * @class QuickStartGuideService
 */
class QuickStartGuideService extends AbstractQuickStartGuideService {
    constructor(config) {
        super();

        this.config = config;
    }
    /**
     * Get quick start guides.
     *
     * @param {Function} successCallback - Success callback.
     * @param {Function} errorCallback - Error callback.
     * @returns {Promise} fetch quick start guide promise.
     */
    fetchQuickStartGuides(successCallback, errorCallback) {
        return new Promise(resolve => {
            setTimeout(() => {
                const {excludedGuides, explicitTheme} = this.config;
                const guidesContentGenerator = new GuidesContentGenerator(excludedGuides, explicitTheme);

                resolve(guidesContentGenerator.generate());
            }, DELAY);
        })
            .then(successCallback)
            .catch(errorCallback);
    }
}

export default QuickStartGuideService;
